
            const data = {"name":"vectorLeft","data":{"width":"25","height":"26","viewBox":"0 0 25 26","data":"<path pid=\"0\" d=\"m14.987 6.682 1.273 1.272L11.214 13l5.046 5.046-1.273 1.272-5.045-5.045L8.738 13l1.204-1.273 5.045-5.045Z\" _fill=\"#333\"/>","originalColors":[{"type":"fill","color":"#333"}],"stopColors":[]}}
        
                module.exports = data
                